import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { MembershipRole } from 'tdc-web-backend/enums/enums';
import { useTranslation } from 'react-i18next';
import { primaryDark, primaryLight } from '../../../../../../utils/color';
import { ReactComponent as RadioIcon } from '../../../../../../assets/icons/radio.svg';
import { ReactComponent as RadioCheckIcon } from '../../../../../../assets/icons/radio-check.svg';

const MembershipRoles = ({ disabled = false }: { disabled?: boolean }) => {
  const form = useFormContext();
  const { t } = useTranslation();

  return (
    <Stack spacing={1.5}>
      <Typography variant="heading3" color="primaryDark.500">
        {t('settings.members.role')}
      </Typography>
      <RadioGroup
        aria-labelledby="role-options"
        name="membershipRole"
        value={form.watch('membershipRole')}
        onChange={(_, newVisibility) => {
          if (newVisibility !== null) {
            form.setValue('membershipRole', newVisibility as MembershipRole);
          }
        }}
        sx={{
          flexDirection: 'column',
        }}
      >
        <Stack
          sx={{
            p: '0.5rem 0.75rem',
            borderRadius: '0.5rem',
            border: `1px solid ${primaryDark[200]}`,
          }}
        >
          <FormControlLabel
            value={MembershipRole.Editor}
            control={<Radio icon={<RadioIcon />} checkedIcon={<RadioCheckIcon />} />}
            label={t('settings.members.editor')}
            sx={{
              '& .Mui-checked': {
                color: primaryLight[500],
              },
            }}
            componentsProps={{ typography: { variant: 'bodySemiBold2', pl: '15px' } }}
            disabled={disabled}
          />
          <Typography variant="body3" sx={{ pl: 5 }}>
            {t('settings.members.editorDescription')}
          </Typography>
        </Stack>
        <Stack
          sx={{
            p: '0.5rem 0.75rem',
            borderRadius: '0.5rem',
            border: `1px solid ${primaryDark[200]}`,
            mt: 1.5,
          }}
        >
          <FormControlLabel
            value={MembershipRole.Admin}
            control={<Radio icon={<RadioIcon />} checkedIcon={<RadioCheckIcon />} />}
            label={t('settings.members.admin')}
            sx={{
              '& .Mui-checked': {
                color: primaryLight[500],
              },
            }}
            componentsProps={{ typography: { variant: 'bodySemiBold2', pl: '15px' } }}
            disabled={disabled}
          />
          <Typography variant="body3" sx={{ pl: 5 }}>
            {t('settings.members.adminDescription')}
          </Typography>
        </Stack>
      </RadioGroup>
    </Stack>
  );
};

export default MembershipRoles;
